var Marionette = require('marionette')
var _ = require('lodash')

// -- Filter Text --- //
var FilterText = Marionette.View.extend({
  template: require('../templates/filter-text.html'),
  className: 'filter-text',
  events: {
    'change .js-text-value': 'onValueChange'
  },
  modelEvents: {
    'change': 'modelChange'
  },
  modelChange: function () {},
  initialize: function () {},
  onValueChange: function () {
    this.model.set('value', this.el.querySelector('.js-text-value').value)
  },
  templateContext: function () {
    var self = this
    return {
      'getValue': function () {
        var value = self.model.get('value') || self.model.get('selectedValues')
        if (value === false) value = ''
        return value
      }
    }
  },
  onActivate: function () {
    var inputField = this.el.querySelector('.js-text-value')
    setTimeout(function () {
      inputField.focus()
      inputField.select()
    }, 0)
  }
})

module.exports = FilterText



// WEBPACK FOOTER //
// ./js/components/devices-filter/views/filter-text.js